import React, { Component } from 'react';

import Constants from '../Constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMedal, faStar, faTrophy } from '@fortawesome/free-solid-svg-icons'

import '../styles/AccoladeIcons.css';

// The accolades a player currently holds, drawn beside their name: on today's
// scoreboard rows and on their chat messages, so a player recognised in one
// place is recognised in the other. Each rank is null when not held.
class AccoladeIcons extends Component {
  render() {
    const { name, yesterdayRank, lastWeekRank, lastSeasonRank, seasonsStarted } = this.props;

    // The accolade ladder is star (a day) -> medal (a week) -> trophy (a
    // season). Before there are seasons the week is the top rung and keeps the
    // trophy it has always had, so nothing on the board changes until the
    // first season begins.
    const weeklyIcon = seasonsStarted ? faMedal : faTrophy;
    const weeklyIconName = seasonsStarted ? "medal" : "trophy";

    // Nothing at all rather than an empty box, which would still take a gap
    // beside the name wherever the name is laid out with one.
    if (yesterdayRank === null && lastWeekRank === null && lastSeasonRank === null) {
      return null;
    }

    return (
      <span className="accolade-icons">
        { lastSeasonRank !== null &&
          <FontAwesomeIcon
            icon={faTrophy}
            className={`accolade-icon accolade-icons-trophy-${Constants.ACCOLADE_COLORS[lastSeasonRank]}`}
            title={`${name} achieved last season's ${Constants.SCORE_DESCRIPTORS[lastSeasonRank]} total!`}
          />
        }
        { lastWeekRank !== null &&
          <FontAwesomeIcon
            icon={weeklyIcon}
            className={`accolade-icon accolade-icons-${weeklyIconName}-${Constants.ACCOLADE_COLORS[lastWeekRank]}`}
            title={`${name} achieved last week's ${Constants.SCORE_DESCRIPTORS[lastWeekRank]} score!`}
          />
        }
        { yesterdayRank !== null &&
          <FontAwesomeIcon
            icon={faStar}
            className={`accolade-icon accolade-icons-star-${Constants.ACCOLADE_COLORS[yesterdayRank]}`}
            title={`${name} achieved yesterday's ${Constants.SCORE_DESCRIPTORS[yesterdayRank]} score!`}
          />
        }
      </span>
    );
  }
}

export default AccoladeIcons;
